// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Sh","subtitle":"Th","contentWrap":"Uh","imgWrap":"Vh","heading":"Wh","copy":"Xh"};